export { default } from "./SlideShow";
export * from "./SlideShow";